import { render, staticRenderFns } from "./DetailDoc.vue?vue&type=template&id=552e31e6&scoped=true"
import script from "./DetailDoc.vue?vue&type=script&lang=js"
export * from "./DetailDoc.vue?vue&type=script&lang=js"
import style0 from "./DetailDoc.vue?vue&type=style&index=0&id=552e31e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e31e6",
  null
  
)

export default component.exports